import React, { PureComponent } from 'react';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

const TextFieldWrap = ({ placeholder, value, inputRef, onClick, disabled = false }) => {
    return (
        <input
            ref={inputRef}
            className="form-control"
            type="text"
            placeholder={placeholder}
            value={value || null}
            onClick={onClick}
            disabled={disabled}
        />
    );
};

class Calendar extends PureComponent {
    formatDate = value => {
        const { isUsFormat } = this.props;
        const dateFormat = isUsFormat ? 'MM-DD-YYYY' : 'DD-MM-YYYY';
        let formatedDate = null;
        if (value && moment.utc(value).isValid()) {
            formatedDate = moment.utc(value).format(dateFormat);
        }
        return formatedDate;
    };

    render() {
        const {
            input,
            input: { value, name, onChange },
            label,
            isUsFormat,
            ...custom
        } = this.props;
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                    value={moment.utc(value)}
                    onChange={e => onChange(e._d)}
                    openTo="year"
                    inputRef={el => (this.inputElement = el)}
                    TextFieldComponent={({ onClick, inputRef, disabled }) => {
                        return (
                            <TextFieldWrap
                                name={name}
                                value={this.formatDate(value) || value}
                                inputProps={input}
                                onClick={onClick}
                                inputRef={inputRef}
                                disabled={disabled}
                            />
                        );
                    }}
                    format={isUsFormat ? 'MM-DD-YYYY' : 'DD-MM-YYYY'}
                    {...custom}
                />
            </MuiPickersUtilsProvider>
        );
    }
}

export default Calendar;
